import {Component} from '@angular/core';

import {DynamicComponent} from "../../dynamic-component";

@Component({
    templateUrl: './text-area.component.html',
})
export class TextAreaComponent extends DynamicComponent {

}
